namespace $.$$ {

	$mol_style_define( $shm_tests_app, {

		height: '100%',
		minHeight: 0,

		Menu: {
			flex: {
				basis: '20rem',
			},
		},

		Group_expand: {
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			zIndex: $mol_layer.float,
			width: '1.5rem',
			minWidth: '1.5rem',
			maxWidth: '1.5rem',
			minHeight: 0,
			padding: 0,
			alignItems: 'center',
			justifyContent: 'center',
		},

		Group_row: {
			alignItems: 'stretch',
			height: '40px',
			minHeight: '40px',
			maxHeight: '40px',
			position: 'relative',
			width: '100%',
		},

		Group_title: {
			flex: {
				grow: 1,
			},
			color: $mol_theme.text,
			padding: {
				right: $mol_gap.block,
				left: '1.5rem',
			},
			alignItems: 'center',
		},

		Group_children: {
			margin: {
				bottom: $mol_gap.text,
			},
			width: '100%',
			minWidth: 0,
		},

		Scenario_node: {
			position: 'relative',
			width: '100%',
			minWidth: 0,
			padding: {
				left: '1.5rem',
			},
		},

		Menu_item: {
			width: '100%',
			minWidth: 0,
		},

		Menu_link: {
			width: '100%',
			minWidth: 0,
		},

		Menu_link_title: {
			width: '100%',
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},

		Scenario_guide_vertical: {
			position: 'absolute',
			left: '.75rem',
			top: 0,
			width: '1px',
			background: {
				color: $mol_theme.line,
			},
			pointerEvents: 'none',
		},

		Scenario_guide_horizontal: {
			position: 'absolute',
			left: '.75rem',
			top: '50%',
			width: '.75rem',
			height: '1px',
			background: {
				color: $mol_theme.line,
			},
			pointerEvents: 'none',
		},

		Empty: {
			Body_content: {
				padding: $mol_gap.block,
			},
		},

	} )

}
